import { LoadablePaint } from '@confluence/loadable';

export const WhiteboardRouteComponentLoader = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-WhiteboardRouteComponent" */ './WhiteboardRouteComponent.tsx'
		),
});
